class FeaturedCollectionPRG {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.featured-collection-prg__tab');
    this.tabContents = container.querySelectorAll('.featured-collection-prg__tab-content');
    this.currentTab = 0;
    
    this.init();
  }

  init() {
    if (this.tabs.length === 0) return;
    
    // Add event listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.switchTab(index);
        }
      });
    });

    // Initialize with first tab active
    this.switchTab(0);
  }

  switchTab(index) {
    if (index === this.currentTab || index >= this.tabs.length) return;

    // Remove active class from current tab and content
    this.tabs[this.currentTab].classList.remove('active');
    this.tabContents[this.currentTab].classList.remove('active');

    // Add active class to new tab and content
    this.tabs[index].classList.add('active');
    this.tabContents[index].classList.add('active');

    // Update current tab index
    this.currentTab = index;

    // Trigger custom event for potential external listeners
    this.container.dispatchEvent(new CustomEvent('tabChanged', {
      detail: { 
        previousTab: this.currentTab, 
        currentTab: index,
        tabElement: this.tabs[index],
        contentElement: this.tabContents[index]
      }
    }));
  }

  // Public method to programmatically switch tabs
  setActiveTab(index) {
    this.switchTab(index);
  }

  // Public method to get current active tab
  getActiveTab() {
    return this.currentTab;
  }
}

// Initialize all FeaturedCollection-PRG sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.featured-collection-prg');
  containers.forEach(container => {
    new FeaturedCollectionPRG(container);
  });
});

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FeaturedCollectionPRG;
} 